export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const notificationCount = element.getAttribute(
            'data-notification-count'
        );
        trackingService.trackEventObject({
            analyticsName: 'notifications.main-menu-notification.show',
            numberValue: notificationCount,
            eventFlags: 'start',
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/trackNotificationShow.js